import { lazy } from 'react';

import { BaseRoles, RoleVariantEnum } from 'common/graphql/types';
import { SUPPORT_ROLES } from 'common/utils/user';

export const routes = [
    {
        component: lazy(() => import('module/study/StudyListPage')),
        permissions: ['Study_Read', 'Study_Create', 'Study_Edit', 'Study_Delete'],
        role: [
            BaseRoles.AdminId,
            BaseRoles.UserId,
            RoleVariantEnum.StudyBuilder,
            RoleVariantEnum.Librarian,
            RoleVariantEnum.StudySupport,
            RoleVariantEnum.ClinicalTrialLead,
            RoleVariantEnum.BlindedStudyManager,
            RoleVariantEnum.AdminReadOnly,
            ...SUPPORT_ROLES,
        ],
        path: '/study',
        block: true,
    },
    {
        component: lazy(() => import('module/study/StudyListPage')),
        permissions: ['Study_Read', 'Study_Create', 'Study_Edit', 'Study_Delete'],
        role: [
            BaseRoles.AdminId,
            BaseRoles.UserId,
            RoleVariantEnum.StudyBuilder,
            RoleVariantEnum.Librarian,
            RoleVariantEnum.StudySupport,
            RoleVariantEnum.AdminReadOnly,
            ...SUPPORT_ROLES,
        ],
        path: '/customer/:customerId/study',
    },
];
